import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { actionCreators } from "../../../store/integration/VSTSStore";
import { SourceType } from "../../../store/ExternalEpmConnectStore";
import { IConnectionsState } from "../../../store/integration/common";
import VSTSConnectionEdit from "../../integration/Vsts/VSTSConnectionEdit";
import BasicAuthConnectionCard from './BasicAuthConnectionCard';


type OwnProps = {}
type StateProps = { connections: IConnectionsState };
type Props = StateProps & OwnProps & typeof actionCreators;
const AzureDevOpsConnectionCard = (props: Props) => <BasicAuthConnectionCard
    system={SourceType.VSTS}
    connections={props.connections.data}
    renderConnect={(onCreated, onDismiss) => <VSTSConnectionEdit onDismiss={onDismiss}
        onCreated={(connectionId: string) => {
            props.loadConnections();
            onCreated(connectionId);
        }} />}
/>;
function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { connections: state.vsts.connections }
}
export default connect(mapStateToProps, actionCreators)(AzureDevOpsConnectionCard);